// extracted by mini-css-extract-plugin
export default {"uploader-marketing-works":"uploader-marketing-works___aXayy"};